// logger — tiny leveled console wrapper.
// ----------------------------------------
// `debug` / `info` are no-ops in production builds (import.meta.env.PROD), so dev
// diagnostics never reach a customer's console. `warn` / `error` ALWAYS pass
// through, so genuine failure diagnostics stay visible in production (silencing
// those would blind us when something breaks live).
//
// Pass-through with no added prefix, so existing `vi.spyOn(console, ...)` test
// spies still match the forwarded calls. `debug` maps to `console.log` (not
// `console.debug`) so dev output looks identical to the calls it replaced.

function isProd(): boolean {
  return Boolean(import.meta.env.PROD);
}

export const logger = {
  debug(...args: unknown[]): void {
    if (!isProd()) console.log(...args);
  },
  info(...args: unknown[]): void {
    if (!isProd()) console.info(...args);
  },
  warn(...args: unknown[]): void {
    console.warn(...args);
  },
  error(...args: unknown[]): void {
    console.error(...args);
  },
};
